// src/utils/currency-switcher.js
var currencySwitcher = (inputText) => {
  const currencyForm = JSON.parse(
    document.querySelector("#country-data").innerHTML
  );
  if (currencyForm) {
    const filteredForm = currencyForm.countries.filter(
      (item) => item.country.includes(inputText)
    );
    const options = document.querySelectorAll(".custom-select__options");
    options.forEach((optie) => {
      optie.innerHTML = "";
      filteredForm.forEach((item) => {
        const optionHTML = `<li class="disclosure__item" tabindex="-1">
      <a href="#" data-value="${item.country_iso_code}">
        <span> ${// item.country.charAt(0).toUpperCase() + item.country.slice(1)
        item.country}</span>
        <span>
          ${item.currency}
          ${item.symbol}
        </span>
      </a>
    </li>
`;
        optie.insertAdjacentHTML("beforeend", optionHTML);
      });
    });
  }
  const selectorListItem = document.querySelectorAll(".disclosure__item");
  const valueHiddenInput = document.querySelector(".js-hidden-input");
  const form = document.querySelector(".js-currency-form");
  selectorListItem.forEach((item) => {
    item.addEventListener("click", (e) => {
      const itemLink = item.querySelector("a");
      valueHiddenInput.value = itemLink.dataset.value;
      form.submit();
    });
  });
};

// src/extenders/language-modal.js
var LanguageModal = class extends HTMLElement {
  constructor() {
    super();
    const textInput = this.querySelector('input[type="text"]');
    const currencyForm = this.querySelector(".custom-select__options");
    const customSelectToggle = this.querySelector(".custom-select__toggle");
    const closeButton = this.querySelector(".close-button");
    textInput == null ? void 0 : textInput.addEventListener("focus", () => {
      currencyForm.classList.add("custom-select__options--open");
      customSelectToggle.classList.add("custom-select__toggle--open");
    });
    textInput == null ? void 0 : textInput.addEventListener("input", (e) => {
      currencySwitcher(
        e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)
      );
    });
    closeButton.addEventListener("click", () => {
      this.classList.remove("language-modal--open");
    });
    this.addEventListener("click", (e) => {
      if (e.target === this) {
        this.classList.remove("language-modal--open");
      }
    });
  }
};
if (customElements.get("language-modal") === void 0) {
  customElements.define("language-modal", LanguageModal);
}
